jQuery(function($) {
    var delayTimer;
    var currentPage = {}; // Initialize as an object for multiple instances
    var maxPages = {}; // Initialize as an object for multiple instances

    function sendRequest(resetPosts, instanceId) {
      var filter = $('#allekirjoittaneetfilter-' + instanceId);
      //$('#loading').show();
      $.ajax({
        url: filter.attr('action'),
        data: filter.serialize() + '&paged=' + currentPage[instanceId], // Use currentPage object
        type: filter.attr('method'),
        dataType: 'json',
        success: function(response) {
          if (resetPosts) {
            $('#allekirjoittaneetresponse-' + instanceId).html(response.result); // Reset the posts with the new results
          } else {
            $('#allekirjoittaneetresponse-' + instanceId).append(response.result); // Append the new results
          }
          maxPages[instanceId] = parseInt(response.max_pages); // Update the maxPages object with the value from the response
          if (currentPage[instanceId] >= maxPages[instanceId] || response.result.trim() === '') {
            $('#load-more-button-' + instanceId).hide(); // Hide the button if all posts have been loaded or there are no more posts
          } else {
            $('#load-more-button-' + instanceId).show(); // Show the button if there are more posts to load
            $('#load-more-button-' + instanceId).blur(); // Remove focus
          }

          // Replace history state to prevent form resubmission on back navigation
          if (window.history.replaceState) {
              window.history.replaceState(null, null, window.location.href);
          }
        },
        complete: function() {
         // $('#loading').hide();
        }
      });
    }

    function updatePosts(instanceId) {
        clearTimeout(delayTimer); // Clear the previous timer
        delayTimer = setTimeout(function() {
          currentPage[instanceId] = 1; // Reset the current page number to 1 when the filter changes
          var resetPosts = true; // Flag to indicate if the existing posts should be reset

          $('#allekirjoittaneetresponse-' + instanceId).empty(); // Empty the existing posts
          $('#load-more-button-' + instanceId).show(); // Show the "Load More" button

          sendRequest(resetPosts, instanceId); // Send the request with the updated filter
        }, 500);
    }

    // Initialize event listeners for each instance of the form
    $('[id^="allekirjoittaneetfilter-"]').each(function() {
        var instanceId = $(this).attr('id').split('-')[1]; // Extract instance ID from form ID
        currentPage[instanceId] = 1; // Initialize currentPage for each instance
        maxPages[instanceId] = parseInt($('#max-pages').val()); // Initialize maxPages for each instance

        sendRequest(false, instanceId); // Send the initial request when the page finishes loading

        $('#allekirjoittaneetfilter-' + instanceId + ' input').on('change', function() {
            updatePosts(instanceId); // Update posts when a filter is changed
        });

        // Reset the form when the reset button is clicked
        $('#allekirjoittaneetfilter-' + instanceId + ' #reset').on('click', function() {
            var checkboxes = $('#allekirjoittaneetfilter-' + instanceId + ' .checkbox-container input');

            // Uncheck all checkboxes and remove active class
            checkboxes.each(function() {
                $(this).prop('checked', false).parent().removeClass('active');
            });

            updatePosts(instanceId);
        });

        // Toggle active class for checkboxes
        $('#allekirjoittaneetfilter-' + instanceId + ' .checkbox-container input').on('change', function() { // Fix typo here
            if ($(this).is(':checked')) {
                $(this).parent().addClass('active');
            } else {
                $(this).parent().removeClass('active');
            }
        });

        // Add a click event listener to the "Load More" button
        $('#load-more-button-' + instanceId).on('click', function() {
            currentPage[instanceId]++; // Increment the current page number
            if (currentPage[instanceId] <= maxPages[instanceId]) {
                sendRequest(false, instanceId); // Pass instanceId to sendRequest
            } else {
                $(this).hide(); // Hide the button if all posts have been loaded
            }
        });
    });
});
